import * as constants from '../constants/CONSTANT';

const QuoteProductApi = {
  async createQuoteProducts({ quoteId, items, deletedIds = [] }) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `${constants.API_BASE_URL}/api/quoteproduct`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          quoteId,
          items,
          deletedIds,
        }),
      }
    );

    return await response.json();
  },
};

export default QuoteProductApi;
